import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '{{percentage}}% zniżki na wybrane pozycje',
  [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '{{percentage}}% zniżki od łącznej wartości zamówienia',
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Darmowa pozycja przy zakupie pozycji',
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Darmowa pozycja przy wartości zamówienia',
  [OFFER_KIND.BOGO_HALF_PRICE]: 'Kup jeden, dostań jeden w połowie ceny',
  [OFFER_KIND.BOGO]: 'Kup jeden, dostań jeden gratis',
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: '{{amount}} zniżki na wybrane pozycje',
  [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: '{{amount}} zniżki przy wartości zamówienia',
};
